import { SVGProps } from 'react';

const Minus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className={props.className}
    onClick={props.onClick}
    fill={props.fill || 'currentColor'}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 20}
    height={props.height || 20}
    {...props}>
    <path d="M19 11H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2z" />
  </svg>
);

export default Minus;
